export const initialState = {
	// Object met active regions (voor URL)
	activeRegions: [],
	// String met active query input zodat je kan op enter kan duwen & event gedispatcht wordt (voor URL)
	activeQuery: "",
	// Actieve query nadat je op de zoeken knop duwt
	queryValue: "",
	// Active location object om call te maken met gemeente/postcode, lat & lng
	activeLocation: {},
	// Locatie ingevuld = toon delete button, geen locatie = toon geen delete button
	locationValue: "",
	// Active categories string met | zodat deze meteen gebruikt nan worden om call te maken (voor URL)
	activeCategories: "",
	// Verwerkt object waar label & slug van categorie en subcategorie in zitten
	activeCategoriesObj: [],
	// Verzameling van alle categorieën
	allCategories: [],
	// Array met actieve vakken (voor url)
	activeSubjects: [],
	// Huidige pagina waarop men zich bevindt (voor URL)
	currentPage: "",
	// Totaal aantal paginas voor pagination
	totalPages: "",
	// Totaal aantal zoekresultaten
	totalResults: "",
	// Pending staat op true wanneer de content geladen wordt & dan wordt de loading balk getoond
	pending: false,
	// Toggle om state te geven of de mobiele weergave getoond dient te worden of niet
	facetFilters: false,
	// Pagina intro zetten wanneer deze ingevuld dient te worden uit call
	pageIntro: "",
};
